import script from "./brandManufacturers.vue?vue&type=script&lang=ts&setup=true"
export * from "./brandManufacturers.vue?vue&type=script&lang=ts&setup=true"

import "./brandManufacturers.vue?vue&type=style&index=0&id=00e2f087&lang=less&scope=true"

const __exports__ = script;

export default __exports__